// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { UserConfigsService } from '../services/user-configs.service';
import { UserConfigs } from '../models/user-configs.model';
import { Role } from '../models/role.model';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard  {

  constructor(private userService: UserConfigsService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    // Require one role for guard.
    const roles: Array<Role> = route.data['roles'] as Array<Role>;
    if (roles == null || roles.length < 1)
      return false;

    return this.canActivateByRoles(roles);
  }

  canActivateByRoles(roles: Role[]): Observable<boolean> {
    return this.userService.getUserConfigs().pipe(
      map((user: UserConfigs) => user.userRoles.some(ur => roles.indexOf(ur) > -1)),
      catchError(() => {
        //In theory this should only happen if the server is down or something similar. We might want to redirect to an error page
        console.log('Calling userService.getUserConfigs returned an error');
        return of(false);
      })
    );
  }
}
